export default {
  product_info: 'Info produs',
  return: 'Înapoi la opțiuni',
};
